import Map from './components/map';

function App() {
  return (
    <div>
      <Map />
    </div>
  );
}

export default App;